var _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 1.33203,
    y: 25.6064,
    width: 33.7043,
    height: 33.7043,
    rx: 7.09565,
    transform: "rotate(-45 1.33203 25.6064)",
    fill: "#CBD4E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.885,
    y: 10.885,
    width: 21.23,
    height: 26.23,
    fill: "#D7EDE5",
    stroke: "#024E82",
    strokeWidth: 1.77
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.885,
    y: 19.885,
    width: 13.23,
    height: 13.23,
    fill: "#B7D972",
    stroke: "#024E82",
    strokeWidth: 1.77
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 39.5,
    width: 14,
    height: 1,
    fill: "#B7D972",
    stroke: "#024E82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoveIcon);
export default __webpack_public_path__ + "static/media/stove-icon.bf42656e2ba62dcface197fb5225bb95.svg";
export { ForwardRef as ReactComponent };